import { api } from '@/api/client';

export function getReaderFilesQueryOptions(personId: string) {
  return {
    queryKey: ['readerFiles', personId] as const,
    queryFn: () => api.readerFiles.list(personId),
    staleTime: 60_000,
  };
}
